module.exports = __webpack_public_path__ + "img/user-sz-icon.4547ebe8.png";